module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('quill-editor', {
    ref: "myTextEditor",
    attrs: {
      "options": _vm.editorOption
    },
    on: {
      "change": _vm.onChange
    },
    model: {
      value: (_vm.content),
      callback: function($$v) {
        _vm.content = $$v
      },
      expression: "content"
    }
  }, [_c('div', {
    attrs: {
      "slot": "toolbar",
      "id": "toolbar"
    },
    slot: "toolbar"
  }, [_c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-bold",
    attrs: {
      "type": "button"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-italic",
    attrs: {
      "type": "button"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-underline",
    attrs: {
      "type": "button"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-strike",
    attrs: {
      "type": "button"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-blockquote",
    attrs: {
      "type": "button"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-code-block",
    attrs: {
      "type": "button"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-header",
    attrs: {
      "type": "button",
      "value": "1"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-header",
    attrs: {
      "type": "button",
      "value": "2"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-list",
    attrs: {
      "type": "button",
      "value": "ordered"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-list",
    attrs: {
      "type": "button",
      "value": "bullet"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-script",
    attrs: {
      "type": "button",
      "value": "sub"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-script",
    attrs: {
      "type": "button",
      "value": "super"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-indent",
    attrs: {
      "type": "button",
      "value": "-1"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-indent",
    attrs: {
      "type": "button",
      "value": "+1"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-direction",
    attrs: {
      "type": "button",
      "value": "rtl"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('select', {
    staticClass: "ql-size"
  }, [_c('option', {
    attrs: {
      "value": "small"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "selected": ""
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "large"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "huge"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('select', {
    staticClass: "ql-header"
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "selected": "selected"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('select', {
    staticClass: "ql-color"
  }, [_c('option', {
    attrs: {
      "selected": "selected"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#ff0000"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#959595"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#7b0c00"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#ffff00"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#008a00"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#0066cc"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#9933ff"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#ffffff"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#facccc"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#ffebcc"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#ffffcc"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#cce8cc"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#cce0f5"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#ebd6ff"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#bbbbbb"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#f06666"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#ffc266"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#ffff66"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#66b966"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#66a3e0"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#c285ff"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#888888"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#a10000"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#b26b00"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#b2b200"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#006100"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#0047b2"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#6b24b2"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#444444"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#5c0000"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#663d00"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#666600"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#003700"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#002966"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#3d1466"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('select', {
    staticClass: "ql-background"
  }, [_c('option', {
    attrs: {
      "value": "#000000"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#e60000"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#ff9900"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#ffff00"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#008a00"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#0066cc"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#9933ff"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "selected": "selected"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#facccc"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#ffebcc"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#ffffcc"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#cce8cc"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#cce0f5"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#ebd6ff"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#bbbbbb"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#f06666"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#ffc266"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#ffff66"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#66b966"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#66a3e0"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#c285ff"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#888888"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#a10000"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#b26b00"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#b2b200"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#006100"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#0047b2"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#6b24b2"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#444444"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#5c0000"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#663d00"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#666600"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#003700"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#002966"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "#3d1466"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('select', {
    staticClass: "ql-font"
  }, [_c('option', {
    attrs: {
      "selected": "selected"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "serif"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "monospace"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('select', {
    staticClass: "ql-align"
  }, [_c('option', {
    attrs: {
      "selected": "selected"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "center"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "right"
    }
  }), _vm._v(" "), _c('option', {
    attrs: {
      "value": "justify"
    }
  })])]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-clean",
    attrs: {
      "type": "button"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-link",
    attrs: {
      "type": "button"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.imgClick
    }
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 18 18"
    }
  }, [_c('rect', {
    staticClass: "ql-stroke",
    attrs: {
      "height": "10",
      "width": "12",
      "x": "3",
      "y": "4"
    }
  }), _vm._v(" "), _c('circle', {
    staticClass: "ql-fill",
    attrs: {
      "cx": "6",
      "cy": "7",
      "r": "1"
    }
  }), _vm._v(" "), _c('polyline', {
    staticClass: "ql-even ql-fill",
    attrs: {
      "points": "5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12"
    }
  })])])]), _vm._v(" "), _c('span', {
    staticClass: "ql-formats"
  }, [_c('button', {
    staticClass: "ql-video",
    attrs: {
      "type": "button"
    }
  })])])]), _vm._v(" "), _c('crop-upload', {
    attrs: {
      "width": _vm.width,
      "height": _vm.height,
      "fileName": _vm.fileName,
      "uploadUrl": _vm.uploadUrl
    },
    on: {
      "uploadSuccess": _vm.onUploadSuccess
    },
    model: {
      value: (_vm.showCrop),
      callback: function($$v) {
        _vm.showCrop = $$v
      },
      expression: "showCrop"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-53329b0a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/yunying/about/Quilleditor.vue
// module id = 1029
// module chunks = 0